
import md5 from "js-md5";
import { IGlobalState } from "@/store";
import AREA_TYPE, { IAreaItem } from "@/typings/area";
import {
  computed,
  defineComponent, onBeforeUnmount,
  onMounted,
  reactive,
  ref,
  toRefs,
} from "vue";
import { useStore } from "vuex";
import { useAreaList, setCurrentAreaItem } from "@/hooks/area";
import {
  validateUserPassword,
  validateMobile,
  validateInfoCode,
} from "@/utils/validate";
import { uploadFile } from "@/utils/aliOss";
import { ElMessage } from "element-plus";
import {
  findAppId,
  findsafetyid,
  findsmscodebymobile,
  checkMobileCode,
  registerUser,
} from "@/service/api";
import loginModal from "../modules/login.vue";
declare let TencentCaptcha: any;

declare global{
  interface Window {
    initAliyunCaptcha: any;
  }
}

export default defineComponent({
  components: {
    loginModal,
  },
  setup() {
    const validateRePass = (rule: any, value: string, callback: any) => {
      if (value !== state.formItem.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    const store = useStore<IGlobalState>();
    const formItemRef = ref<any>(null);
    const captcha = ref<any>(null);

    const state = reactive({
      stepNum: 1,
      type: 1,
      reSendTime: 120,
      formItem: {
        enterpriseFullName: "",
        enterpriseShortName: "",
        mobile: "",
        validateCode: "",
        unifiedSocialCreditCode: "",
        provinceId: computed(() => store.state.area.provinceId),
        provinceName: "",
        cityId: computed(() => store.state.area.cityId),
        cityName: "",
        districtId: computed(() => store.state.area.districtId),
        districtName: "",
        password: "",
        rePassword: "",
        businessLicense: "",
      },
      rules: {
        enterpriseFullName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        enterpriseShortName: [
          { required: true, message: "请输入公司简称", trigger: "blur" },
        ],
        mobile: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: validateMobile, trigger: "blur" },
        ],
        validateCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        unifiedSocialCreditCode: [
          { required: true, message: "请输入统一社会信用码", trigger: "blur" },
          { validator: validateInfoCode, trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validateUserPassword, trigger: "blur" },
        ],
        rePassword: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { validator: validateRePass, trigger: "blur" },
        ],
        districtId: [
          { required: true, message: "请选择地区", trigger: "change" },
        ],
      },
      appId: "",
      guid: "",
      uploadUrl: "",
      imgUploadData: {
        host: "",
        key: "",
        policy: "",
        OSSAccessKeyId: "",
        signature: "",
        success_action_status: "",
        "Content-Disposition": "",
      },
      validMobileCode: true,
      visibleModal: false,
      captcha: null,
      captchaButton: null as any,
    });
    // 省
    const provinceId = computed({
      get: () => store.state.area.provinceId,
      set: (val) => {
        store.state.area.provinceId = val;
      },
    });

    // 市
    const cityId = computed({
      get: () => store.state.area.cityId,
      set: (val) => {
        store.state.area.cityId = val;
      },
    });

    // 区
    const districtId = computed({
      get: () => store.state.area.districtId,
      set: (val) => {
        store.state.area.districtId = val;
      },
    });

    const provinces = computed(() => store.state.area.provinces);
    const citys = computed(() => store.state.area.citys);
    const districts = computed(() => store.state.area.districts);
    /**
     * 获取区域列表
     */
    const getAreaData = async () => {
      await useAreaList(
        store,
        state.type,
        state.type === AREA_TYPE.PROVINCE_TYPE
          ? ""
          : state.type === AREA_TYPE.CITY_TYPE
          ? provinceId.value
          : cityId.value
      );
    };
    /**
     * 根据省市区 id获取省市区对应名称
     */
    function findAreaNameById(id: string, type: AREA_TYPE) {
      let sourceArr: IAreaItem[] = [];
      if (type === AREA_TYPE.PROVINCE_TYPE) {
        sourceArr = provinces.value;
      } else if (type === AREA_TYPE.CITY_TYPE) {
        sourceArr = citys.value;
      } else {
        sourceArr = districts.value;
      }
      const curAreaItem: IAreaItem[] = sourceArr.filter(
        (item) => item.id === id
      );

      return curAreaItem[0];
    }
    /**
     * 改变省市区
     */
    async function onProvinceChange(id: string, type: AREA_TYPE) {
      const curAreaItem = findAreaNameById(id, type);
      await setCurrentAreaItem(store, type, curAreaItem);
      if (type === AREA_TYPE.PROVINCE_TYPE) {
        state.type = AREA_TYPE.CITY_TYPE;
      } else if (type === AREA_TYPE.CITY_TYPE) {
        state.type = AREA_TYPE.DISTRICT_TYPE;
      }
      await getAreaData();
    }
    /**
     * 验证手机号
     */
    function checkMobileLegal(value: string) {
      let isLegal = true;
      const reg = new RegExp("^\\d+$");
      const reg2 = new RegExp("^((-\\d+)|(0+))$");
      if (value !== "" && !reg.test(value) && !reg2.test(value)) {
        isLegal = false;
      } else if (value.length != 11) {
        isLegal = false;
      }
      return isLegal;
    }
    /**
     * 点击获取验证码 先显示图形验证码
     */
    async function showCaptcha() {
      if (state.reSendTime == 120 || state.reSendTime == 0) {
        if (state.formItem.mobile == "") {
          ElMessage({ message: "请先输入手机号码", type: "error" });
        } else {
          if (checkMobileLegal(state.formItem.mobile)) {
            // 滑块显示
            // captcha.value.show();
            const div: any = document.getElementById("captcha-button");
            const  res = await findsafetyid()
            if (res && res.code == 1){
              // 获取安全码
              state.guid = res.data
              if (state.guid){
                div.click();
              }
            }else {
              ElMessage({ message: res.msg, type: "error" });
            }
          } else {
            ElMessage({ message: "手机号格式不正确", type: "error" });
          }
        }
      }
    }
    /**
     * 验证码时间倒计时
     */
    function dateduSettime(): void {
      if (state.reSendTime == 0) {
        state.reSendTime = 120;
      } else {
        state.reSendTime--;
        setTimeout(function () {
          dateduSettime();
        }, 1000);
      }
    }
    /**
     * 获取验证码
     */
    async function getSmsCodeByMobile(
      guid: string,
      ticket: string,
      randstr: string
    ) {
      dateduSettime();
      const params = {
        guid: guid,
        mobile: state.formItem.mobile,
        userType: 0,
        isRegister: 1,
        verificationCode: ticket,
        randstr: randstr,
        guidEncrypted: md5(guid + "datedu6738b274c68384f3").toUpperCase(),
      };
      const result = await findsmscodebymobile(params);
      if (result.code === 1) {
        ElMessage({ message: "验证码已发送，请注意查收！", type: "success" });
      }
    }
    /**
     * 发送手机验证码
     */
    async function queryMobieQuid(ticket: string, randstr: string) {
      const result = await findsafetyid();
      //获取安全码
      state.guid = result.data;
      if (state.guid) {
        getSmsCodeByMobile(state.guid, ticket, randstr);
      }
    }
    /**
     * 校验验证码
     */
    function checkValidateCode() {
      const params = {
        guid: state.guid,
        mobile: state.formItem.mobile,
        mobilecode: state.formItem.validateCode,
      };
      checkMobileCode(params)
        .then(function (res: any) {
          if (res.code == 1) {
            state.validMobileCode = true;
          }else{
            state.validMobileCode = false;
            //  ElMessage({
            //   message: res.msg,
            //   type: "error",
            // });
            // return;
          }
        })
        .catch(function (error: any) {
          state.validMobileCode = false;
        });
    }
    /**
     * 获取腾讯appId
     */
    async function getTencentAppId() {
      const result = await findAppId();
      if (result.code == 1) {
        state.appId = result.data;
        captcha.value = new TencentCaptcha(
          state.appId.toString(),
          function (res: any) {
            if (res.ret === 0) {
              queryMobieQuid(res.ticket, res.randstr);
            }
          },
          { needFeedBack: false }
        );
      }
    }
    /**
     * 点击上传图片来触发上传文件的input
     */
    function uploadFileClick() {
      document.getElementById("uploadImage")!.click();
    }
    /**
     * input选择完文件后触发
     */
    function toUpload(e: any) {
      //获取文件信息
      const fileList: Array<File> = [...e.currentTarget.files];
      if (fileList) {
        for (let i = 0; i < fileList.length; i++) {
          const file = fileList[i];
          const fileName: string = file.name;
          const fileExt: string = fileName.substring(
            fileName.lastIndexOf(".") + 1,
            fileName.length
          );
          const maxSize: number = 5 * 1024 * 1024;
          if (file.size > maxSize) {
            ElMessage({
              message: "请上传文件大小不超过5MB的图片！",
              type: "error",
            });
            return;
          }
          console.log(fileExt);
          if (
            fileExt != "jpg" &&
            fileExt != "jpeg" &&
            fileExt != "bmp" &&
            fileExt != "png"
          ) {
            ElMessage({
              message: "请上传jpg、jpeg、bmp、png格式图片！",
              type: "error",
            });
            return;
          }

          uploadFile(
            file,
            "openapi/license",
            "",
            "",
            (uploadState: boolean, filepath: string) => {
              if (uploadState) {
                state.formItem.businessLicense =
                  store.state.app.aliyunPath + "/" + filepath;
              }
            }
          );
        }
      }
    }
    /**
     * 点击注册
     */
    async function registerFactory() {
      formItemRef.value.validate(async (valid: boolean) => {
        if (valid) {
          const params = {
            guid: state.guid,
            mobile: state.formItem.mobile,
            password: state.formItem.password,
            rePassword: state.formItem.rePassword,
            validateCode: state.formItem.validateCode,
            enterpriseFullName: state.formItem.enterpriseFullName,
            enterpriseShortName: state.formItem.enterpriseShortName,
            businessLicense: state.formItem.businessLicense,
            unifiedSocialCreditCode: state.formItem.unifiedSocialCreditCode,
            provinceId: provinceId.value,
            provinceName: findAreaNameById(
              provinceId.value,
              AREA_TYPE.PROVINCE_TYPE
            ).areaName,
            cityId: cityId.value,
            cityName: "",
            districtId: districtId.value,
            districtName: "",
          };
          if(cityId.value){
            params.cityName = findAreaNameById(cityId.value, AREA_TYPE.CITY_TYPE)
              .areaName
          }
          if(districtId.value){
             params.districtName = findAreaNameById(
              districtId.value,
              AREA_TYPE.DISTRICT_TYPE
            ).areaName
          }

          if (state.validMobileCode == false) {
            ElMessage({
              message: "手机验证码输入错误，请验证！",
              type: "error",
            });
            return;
          }

          if (state.formItem.businessLicense == "") {
            ElMessage({ message: "请上传营业执照！", type: "error" });
            return;
          }
          const result = await registerUser(params);
          console.log(result);
          if (result.code == 1) {
            ElMessage({ message: "注册成功！", type: "success" });
            state.stepNum = 2;
            formItemRef.value.resetFields();
          } else {
            ElMessage({ message: result.msg, type: "error" });
          }
        } else {
          console.log("表单校验失败");
          return false;
        }
      });
    }
    /**
     * 打开登录弹框
     */
    function gotoLogin() {
      state.visibleModal = true;
    }
    /**
     * 关闭登录弹框
     */
    function closeModal() {
      state.visibleModal = false;
    }
    /**
     * 返回首页
     */
    function gotoHomePage() {
      location.href='/';
    }

    async function captchaVerifyCallback(captchaVerifyParam: any) {
      // 1.向后端发起业务请求，获取验证码验证结果和业务结果
      const res = await findsmscodebymobile({
        guid: state.guid,
        mobile: state.formItem.mobile,
        userType: 0,
        isRegister: 1,
        verificationCode: captchaVerifyParam,
        type: "ali",
        guidEncrypted: md5(state.guid + "datedu6738b274c68384f3").toUpperCase(),
      })
     if (res && res.code == 1){
       dateduSettime()
       ElMessage({ message: "验证码已发送，请注意查收！", type: "success" });
       return{
         captchaResult: true,
         bizResult: true,
       }
     }else {
       ElMessage({ message: res.msg, type: "error" });
       return{
         captchaResult: false,
         bizResult: false,
       }
     }
    }

    function onBizResultCallback() {
      console.log("onBizResultCallback");
    }

    function getInstance(instance: any) {
      state.captcha = instance;
    }

    /**
     * 初始化阿里云验证码
     */
    function initCaptcha(){
      state.captchaButton = document.getElementById("captcha-button");
      window.initAliyunCaptcha({
        SceneId: "1ae4phvw", // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
        prefix: "us6zk4", // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
        mode: "popup", // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
        element: "#captcha-element", // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        button: "#captcha-button", // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
        captchaVerifyCallback: captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
        onBizResultCallback: onBizResultCallback, // 业务请求结果回调函数，无需修改
        getInstance: getInstance, // 绑定验证码实例函数，无需修改
        slideStyle: {
          width: 360,
          height: 40,
        }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
        language: "cn", // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
      })
    }
    
    /**
     * 页面一开始加载就调用区域省列表
     */
    onMounted(async () => {
      //初始化阿里云验证码
      initCaptcha();
      //获取腾讯appId
      // await getTencentAppId();
      //获取地区省列表
      await getAreaData();
    });

    onBeforeUnmount(()=>{
      state.captchaButton = null;
      // 必须删除相关元素，否则再次mount多次调用 initAliyunCaptcha 会导致多次回调 captchaVerifyCallback
      document.getElementById("aliyunCaptcha-mask")?.remove();
      document.getElementById("aliyunCaptcha-window-popup")?.remove();
    })

    return {
      ...toRefs(state),
      formItemRef,
      provinces,
      citys,
      districts,
      provinceId,
      cityId,
      districtId,
      onProvinceChange,
      registerFactory,
      showCaptcha,
      uploadFileClick,
      toUpload,
      checkValidateCode,
      gotoLogin,
      closeModal,
      gotoHomePage
    };
  }
});
